import React, { useEffect, useState } from 'react'
import { AuthConfigContext, DEFAULT_VALUE } from './auth-config-context'
import { LoadingIndicator } from '../LoadingIndicator'
import api from '../../api'
import config from '../../config'

export const AuthConfigProvider = (props: any) => {
  const [method, setMethod] = useState(null)
  useEffect(() => {
    api.login.getAuthConfig().then(res => {
      const method = res.error ? DEFAULT_VALUE : res.data.data
      setMethod(method as any)
      config.authType = method?.authType;
      config.recoveryType = method?.recoveryType;
    })
  }, [])
  return <AuthConfigContext.Provider value={method || DEFAULT_VALUE}>
    {props.children}
    <LoadingIndicator loading={!method} />
  </AuthConfigContext.Provider>
}